/**
 * Which workspace a host's stored conversation belongs to.
 *
 * Path-rooted workspaces share their host (`acme.com/fr`, `acme.com/de`), so conversation
 * storage keyed by host alone would carry one workspace's session and transcript into
 * another workspace's agent. Once routing resolves the page's workspace, the session and
 * transcript keys for that host carry it, and each workspace keeps its own conversation.
 */
const workspaceByHost = new Map<string, string>();

export function setConversationWorkspace(host: string, workspaceId: string | undefined): void {
    if (workspaceId) workspaceByHost.set(host, workspaceId);
    else workspaceByHost.delete(host);
}

/** Storage key segment for a host's conversation: the host, plus its workspace when routed. */
export function conversationScope(host: string): string {
    const workspaceId = workspaceByHost.get(host);
    return workspaceId ? `${host}@${workspaceId}` : host;
}
